module.exports = __webpack_public_path__ + "static/media/S (66).9799a143.jpg";